import { SignatoryStatus } from '@bca-company-data/models/signatory-status-response';
import * as companyDataActions from '@bca-company-data/store/company-data.actions';
import { CompanyDataActionTypes } from '@bca-company-data/store/company-data.actions';
import { ICompany } from '@bca-shared/models/company';
import { ICompanySignatory } from '@bca-shared/models/company-signatory';

export const INITIAL_STATE: IState = {
  selectedCompany: null,
  validateSignatory: null,
  signatoryStatus: null,
  companyLoading: false,
  companyFetching: false,
  selectUserFromHistoryChecked: false,
  differentContactPersonChecked: false
};

export interface IState {
  readonly selectedCompany: ICompany;
  readonly validateSignatory: ICompanySignatory;
  readonly signatoryStatus: SignatoryStatus;
  readonly companyLoading: boolean;
  readonly companyFetching: boolean;
  readonly selectUserFromHistoryChecked: boolean;
  readonly differentContactPersonChecked: boolean;
}

export function reducer(state: IState = INITIAL_STATE, action: companyDataActions.Action): IState {
  switch (action.type) {
    case CompanyDataActionTypes.DifferentContactPersonChecked: {
      const { checked: differentContactPersonChecked } = action.payload;
      return {
        ...state,
        differentContactPersonChecked
      };
    }
    case CompanyDataActionTypes.SelectUserFromHistoryChecked: {
      const { checked: selectUserFromHistoryChecked } = action.payload;
      return {
        ...state,
        selectUserFromHistoryChecked
      };
    }
    case CompanyDataActionTypes.SetSignatoryStatus: {
      const {status: signatoryStatus} = action.payload;
      return {
        ...state,
        signatoryStatus
      }
    }
    case CompanyDataActionTypes.ResetSignatoryStatus: {
      const resetValue = null
      return {
        ...state,
        signatoryStatus: resetValue
      }
    }
    case CompanyDataActionTypes.SelectCompany: {
      const selectedCompany = action.payload;
      return {
        ...state,
        selectedCompany
      };
    }
    case CompanyDataActionTypes.ValidateSignatory: {
      const validateSignatory = action.payload;
      return {
        ...state,
        validateSignatory
      };
    }
    case CompanyDataActionTypes.CompanyLoading: {
      const { loading: companyLoading } = action.payload;
      return {
        ...state,
        companyLoading
      };
    }
    case CompanyDataActionTypes.CompanyFetching: {
      const { fetching: companyFetching } = action.payload;
      return {
        ...state,
        companyFetching
      };
    }
  }

  return state;
}